import { createSetPropMutation, createClearPropMutation } from '@/store/utils';
import * as types from '@/store/project/mutationTypes';

export default {
  [types.SET_AMOUNT_OF_RUNNING_PROJECTS]: createSetPropMutation('amountOfRunningProjects', {}),
  [types.CLEAR_AMOUNT_OF_RUNNING_PROJECTS]: createClearPropMutation('amountOfRunningProjects', {}),
  [types.CLEAR_ADDING_CONFIGURATION_FLAG]: createClearPropMutation('lastAddingConfigurationActionData', {
    running: false,
    configType: null,
  }),
  [types.SET_ADDING_CONFIGURATION_FLAG]: createSetPropMutation('lastAddingConfigurationActionData', {
    running: false,
    configType: null,
  }),
  [types.SET_DELETE_CONFIGURATION_LOADING]: createSetPropMutation('deleteConfigurationLoading', false),
  [types.CLEAR_DELETE_CONFIGURATION_LOADING]: createClearPropMutation('deleteConfigurationLoading', false),
  [types.SET_SUBDOMAINS_FOR_TLD]: createSetPropMutation('subdomainsForTld', []),
  [types.SET_EMAILS_FOR_TLD]: createSetPropMutation('emailsForTld', []),
  [types.SET_HOSTS_FOR_SUBDOMAIN]: createSetPropMutation('hostsForSubdomain', []),
  [types.SET_LAST_CTC_NODE]: createSetPropMutation('lastCTCNode', {}),
  [types.SET_RISK_SCORE_HISTORY]: createSetPropMutation('riskScoreHistoryPerTld', {}),
  [types.SET_PROJECT_LIST_LOADING]: createSetPropMutation('projectListLoading', false),
  [types.SET_DATA_LOADING]: createSetPropMutation('dataLoading', false),
  [types.CLEAR_TEST_CARDS_DOMAINS]: createClearPropMutation('testCardsDomains', {}),
  [types.SET_TEST_CARDS_DOMAINS]: createSetPropMutation('testCardsDomains', {}),
  [types.SET_HAS_DISCOVERY_FINISHED](state, newItem) {
    Object.keys(newItem).forEach(key => {
      if (Object.keys(state.hasDiscoveryFinished).includes(key)) {
        state.hasDiscoveryFinished[key] = {
          ...state.hasDiscoveryFinished[key],
          ...newItem[key],
        };
      } else {
        state.hasDiscoveryFinished[key] = newItem[key];
      }
    });
  },
  [types.SET_TEST_CARDS_DOMAINS_LAST_SCANNED_DATE]: createSetPropMutation('testCardsDomainsLastScannedDate', {}),
  [types.CLEAR_TEST_CARDS_SUBDOMAINS]: createClearPropMutation('testCardsSubdomains', {}),
  [types.SET_TEST_CARDS_SUBDOMAINS]: createSetPropMutation('testCardsSubdomains', {}),
  [types.SET_TEST_CARDS_CLOUD_ACCOUNTS]: createSetPropMutation('testCardsCloudAccounts', {}),
  [types.CLEAR_TEST_CARDS_HOSTS]: createClearPropMutation('testCardsHosts', {}),
  [types.SET_TEST_CARDS_HOSTS]: createSetPropMutation('testCardsHosts', {}),
  [types.SET_TEST_CARDS_PASSWORD_SPRAY]: createSetPropMutation('testCardsPasswordSpray', {}),
  [types.CLEAR_TEST_CARDS_PASSWORD_SPRAY]: createClearPropMutation('testCardsPasswordSpray', {}),
  [types.SET_CONFIGURATION_CLOUD_ASSETS]: createSetPropMutation('configurationCloudAssets', []),
  [types.SET_CONFIGURATION_BUCKET_ASSETS]: createSetPropMutation('configurationBucketAssets', []),
  [types.SET_CONFIGURATION_SERVICES_ASSETS]: createSetPropMutation('configurationServicesAssets', []),
  [types.SET_CONFIGURATION_SERVICES_COMPLIANCE_OPTIONS]: createSetPropMutation('configurationServicesComplianceOptions', {}),
  [types.SET_SERVICES_ASSETS_LIST_OPTIONS](state, options = {}) {
    state.servicesAssetsListOptions = {
      ...(state.servicesAssetsListOptions || {}),
      ...options,
    };
  },
  [types.SET_CLOUD_SERVICES_SECOND_LEVEL_ITEMS](state, newItem) {
    const uniqueItems = newItem.filter(item => !state.cloudServicesSecondLevelItems.some(existingItem => (
      existingItem.tld === item.tld &&
      existingItem.region === item.region &&
      existingItem.serviceName === item.serviceName &&
      existingItem.checkType === item.checkType
    )));
    state.cloudServicesSecondLevelItems.push(...uniqueItems);
  },
  [types.CLEAR_CLOUD_SERVICES_SECOND_LEVEL_ITEMS](state, itemToClear) {
    state.cloudServicesSecondLevelItems.forEach(item => {
      if (item.tld === itemToClear.domain &&
      item.region === itemToClear.region &&
      item.serviceName === itemToClear.serviceName) {
        this.commit(types.CLEAR_CLOUD_SERVICES_THIRD_LEVEL_ITEMS, {
          domain: item.tld,
          serviceName: item.serviceName,
          region: item.region,
          checkType: item.checkType,
        });
      }
    });
    state.cloudServicesSecondLevelItems = state.cloudServicesSecondLevelItems.filter(item => (
      !(item.tld === itemToClear.domain &&
        item.region === itemToClear.region &&
        item.serviceName === itemToClear.serviceName)
    ));
  },
  [types.SET_CLOUD_SERVICES_THIRD_LEVEL_ITEMS](state, newItem) {
    const uniqueItems = newItem.filter(item => !state.cloudServicesThirdLevelItems.some(existingItem => (
      existingItem.tld === item.tld &&
      existingItem.region === item.region &&
      existingItem.serviceName === item.serviceName &&
      existingItem.checkType === item.checkType &&
      existingItem.status === item.status &&
      existingItem.description === item.description
    )));
    state.cloudServicesThirdLevelItems.push(...uniqueItems);
  },
  [types.CLEAR_CLOUD_SERVICES_THIRD_LEVEL_ITEMS](state, itemToClear) {
    state.cloudServicesThirdLevelItems = state.cloudServicesThirdLevelItems.filter(item => (
      !(item.tld === itemToClear.domain &&
        item.region === itemToClear.region &&
        item.serviceName === itemToClear.serviceName &&
        item.checkType === itemToClear.checkType)
    ));
  },
  [types.SET_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS]: createSetPropMutation('cloudServicesFourthLevelItems', {}),
  [types.CLEAR_CLOUD_SERVICES_FOURTH_LEVEL_ITEMS]: createClearPropMutation('cloudServicesFourthLevelItems', {}),
  [types.SET_CONFIGURATION_SUBDOMAINS]: createSetPropMutation('configurationSubdomains', []),
  [types.SET_CONFIGURATION_HOSTS]: createSetPropMutation('configurationHosts', []),
  [types.SET_CONFIGURATION_CREDENTIALS]: createSetPropMutation('configurationAuthenticationObjects', []),
  [types.SET_CONFIGURATION_DOMAINS]: createSetPropMutation('configurationDomains', []),
  [types.SET_CONFIGURATION_CLOUD_ACCOUNTS]: createSetPropMutation('configurationCloudAccounts', []),
  [types.SET_CONFIGURATION_CLOUD_ACCOUNTS_OPTIONS]: createSetPropMutation('cloudAccountsListOptions', {}),
  [types.SET_CONFIGURATION_CLOUD_ACCOUNTS_OPTIONS](state, options = {}) {
    state.cloudAccountsListOptions = {
      ...(state.cloudAccountsListOptions || {}),
      ...options,
    };
  },
  [types.SET_CONFIGURATION_DOMAIN_TAGS]: createSetPropMutation('configurationDomainTags', []),
  [types.SET_CONFIGURATION_CLOUD_ACCOUNT_TAGS]: createSetPropMutation('configurationCloudAccountTags', []),
  [types.SET_CONFIGURATION_SUBDOMAIN_TAGS]: createSetPropMutation('configurationSubdomainTags', []),
  [types.SET_CONFIGURATION_ORGANIZATION_TAGS]: createSetPropMutation('configurationOrganizationTags', []),
  [types.SET_ORGANIZATIONS_TAGS]: createSetPropMutation('organizationTags', []),
  [types.CLEAR_PORTS_TO_SCORE]: createClearPropMutation('portsToScoreMap', {}),
  [types.SET_PANORAMIC_DATA]: createSetPropMutation('panoramicData', null),
  [types.SET_PORTS_TO_SCORE]: createSetPropMutation('portsToScoreMap', {}),
  [types.CLEAR_TEST_CARDS]: createClearPropMutation('testCards', {}),
  [types.SET_TEST_CARDS]: createSetPropMutation('testCards', {}),
  [types.SET_TEST_TYPES]: createSetPropMutation('testTypes', []),
  [types.SET_PROJECT]: createSetPropMutation('detailedProject', null),
  [types.CLEAR_PROJECT]: createClearPropMutation('detailedProject', null),
  [types.SET_DETAILED_PROJECT_LOADING]: createSetPropMutation('projectLoading', false),
  [types.SET_PROJECTS]: createSetPropMutation('projects', []),
  [types.SET_PROJECT_STATUS](state, { projectId, status }) {
    const project = state.projects.find(currentProject => currentProject.id === projectId);
    if (project) {
      project.status = status;
    }
  },
  [types.CLEAR_PROJECTS]: createClearPropMutation('projects', []),
  [types.SET_PROJECT_LIST_OPTIONS](state, options = {}) {
    state.projectListOptions = {
      ...(state.projectListOptions || {}),
      ...options,
    };
  },
  [types.SET_ADD_TAGS_INTERVAL_RUNNING]: createSetPropMutation('addTagsIntervalRunning', false),
  [types.SET_ADD_TAGS_REF_ID]: createSetPropMutation('addTagsRefId', ''),
  [types.CLEAR_ADD_TAGS_REF_ID]: createClearPropMutation('addTagsRefId', ''),
  [types.SET_PROJECTS_RUNNING_INTERVAL]: createSetPropMutation('projectsRunningInterval', false),
  [types.SET_PROJECTS_PROGRESS]: createSetPropMutation('projectsProgress', 0),
  [types.CLEAR_PROJECTS_PROGRESS]: createClearPropMutation('projectsProgress', 0),
  [types.SET_PROJECTS_REF_ID]: createSetPropMutation('projectsRefId'),
  [types.CLEAR_PROJECTS_REF_ID]: createClearPropMutation('projectsRefId'),
};
